module.exports = __webpack_public_path__ + "img/join_inter_bg2.fc213ef5.png";